<template>

  <sc-card
    :title="app.app_name"
    :imgSrc="app.image_url"
    :link="true"
  >
    <template slot="body">
      <body-card :app="app" />
    </template>

  </sc-card>
</template>

<script>

import { ScCard } from '@intelipost-js/secure-components';
import BodyCard from './body-card/BodyCard.vue';

export default {
  name: 'integrations-self-service-app-card',

  props: {
    app: {
      type: Object,
      required: true,
    },
  },

  components: {
    ScCard,
    BodyCard,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  .sc-card {
    .card-header-button {
      background: none;
      border: none;
    }

    .card-image {
      .img {
        padding-top: 60%;
      }
    }

    .card-menu-button {
      border: none;
      background-color: white;
      margin: 1rem 0 0 0;
    }

  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/app-card/AppCard.vue